import { gql } from '@apollo/client';

export const CRM_AUDIENCE_FIELDS = `
    _id
    name
    filters {
        statuses
        stageKeys
        tags
        emailSubscribed
        businessState
        businessStatuses
    }
    createdAt
    updatedAt
`;

export const LIST_CRM_AUDIENCES = gql`
    query ListCrmAudiences {
        listCrmAudiences {
            ${CRM_AUDIENCE_FIELDS}
        }
    }
`;

export const LIST_CRM_AUDIENCE_MEMBER_COUNTS = gql`
    query ListCrmAudienceMemberCounts {
        listCrmAudienceMemberCounts {
            audienceId
            contactCount
        }
    }
`;

export const LIST_CRM_BOARD_STAGE_LABELS = gql`
    query ListCrmBoardStageLabels {
        listCrmBoardStageLabels {
            boardId
            boardName
            stages {
                key
                name
            }
        }
    }
`;

export const GET_CRM_AUDIENCE = gql`
    query GetCrmAudience($id: String!) {
        getCrmAudience(id: $id) {
            ${CRM_AUDIENCE_FIELDS}
        }
    }
`;

export const PREVIEW_CRM_AUDIENCE = gql`
    query PreviewCrmAudience($filters: CrmAudienceFiltersInput) {
        previewCrmAudience(filters: $filters) {
            count
            contactCount
            includesContacts
            members {
                _id
                firstName
                lastName
                email
                accountId
                businessName
                stageKey
                status
                tags
                emailSubscribed
                enrolledCount
            }
        }
    }
`;
